module.exports = __webpack_public_path__ + "img/barricas_2.a92fbbf0.jpeg";